import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowRight20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M19.0608 9.99997L12.0305 2.96964L10.9698 4.0303L16.1895 9.24997L1.00012 9.24997L1.00012 10.75L16.1895 10.75L10.9698 15.9696L12.0305 17.0303L19.0608 9.99997Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowRight20.displayName = 'ArrowRight20';
export default ArrowRight20;
